export enum TimeEntryDataType {
  Time,
  Money,
  Distance,
}
